import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

const config = {
  apiKey: process.env.FIREBASE_APIKEY,
  authDomain: process.env.FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.FIREBASE_DBURL,
  projectId: process.env.FIREBASE_PROJECTID,
  storageBucket: '',
  messagingSenderId: process.env.FIREBASE_MSGSENDERID
}
firebase.initializeApp(config)
firebase.firestore().settings({timestampsInSnapshots: true})

export default firebase



// WEBPACK FOOTER //
// ./src/api/firebase.js